<template>
  <w-settings-content-template side-title="필터 그룹 목록" :default-side="false">
  <div slot="sideContent" class="side-content" style="padding: 0px;">
    <w-log-baseline-menu @select-node="loadData"></w-log-baseline-menu>
  </div>
  <div slot="content">
    <w-log-baseline-table ref="baselineTable"></w-log-baseline-table>
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';

import WLogBaselineMenu from './components/LogBaselineMenu';
import WLogBaselineTable from './components/LogBaselineTable';

export default {
  name: 'WBaseLineRule',
  components: {
    WSettingsContentTemplate,
    WLogBaselineMenu,
    WLogBaselineTable,
  },
  data() {
    return {
    };
  },
  methods: {
    loadData(value) {
      this.$refs.baselineTable.selectFilterGroup(value);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/LogBaselineSetting.vue